'use strict';

/**
 * module
 */
import { anchor } from './module/_anchor';
import { hover } from './module/_hover';
import { inview } from './module/_inview';
import { responsive } from './module/_responsive';
import { fitimg } from './module/_fitimg';
import { toggle } from './module/_toggle';
import { scrollbar } from './module/_scrollbar';
import { nav } from './module/_nav';
// import 'ie11-custom-properties';

/**
 * main
 */
const main = (() => {
    /**
     * loaded
     */
    const loaded = () => {
        setTimeout(() => {
            $('body').addClass('is-loaded');

            setTimeout(() => {
                inview.init();
            }, 800);
        }, 100);
    };

    /**
     * scrolled
     */
    const scrolled = () => {
        if ($(window).scrollTop() >= $(window).height()) {
            $('body').addClass('is-scrolled');
        }
        else {
            $('body').removeClass('is-scrolled');
        }

        // topic.init();
    };

    /**
     * resized
     */
    const resized = () => {
        responsive.init();
        // resizeVh();
    };

    // const breakPoint = 769;
    // const resizeVh = () => {
    //     let vh = $(window).outerHeight() * 0.01;
    //     const w = parseInt($('.layout-container').width());

    //     if (w > breakPoint) {
    //         if(($(window).outerHeight() / w) < (890 / 1920)){
    //             vh = (w / 1920 * 890 / 100);
    //         }
    //         if(($(window).outerHeight() / w) > (890 / 1440)){
    //             vh = (w / 1440 * 890 / 100);
    //         }
    //     }

    //     document.documentElement.style.setProperty('--vh', vh + 'px');
    // }

    /**
     * init
     */
    const init = () => {
        scrolled();
        resized();

        anchor.init();
        hover.init();
        fitimg.init();
        toggle.init();
        scrollbar.init();
        nav.init();

        // let vh = $(window).outerHeight() * 0.01;
        // document.documentElement.style.setProperty('--vh', vh + 'px');

        const urlHash = location.hash;
        if(urlHash){
            const target = document.getElementById('tweet');
            let offset = $('.layout-header').height();
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if(mutation.target.innerHTML.indexOf('sc_grid_more_btn') != -1){
                        observer.disconnect();

                        setTimeout(() => {
                            const targetPosition = $(urlHash).offset().top - offset;
                            $(window).scrollTop(targetPosition);
                            loaded();
                        }, 900);
                    }
                });
            });
            const config = {
                childList: true,
                subtree: true
            };
            observer.observe(target, config)
        } else {
            const target = document.getElementById('tweet');
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if(mutation.target.innerHTML.indexOf('sc_grid_more_btn') != -1){
                        observer.disconnect();

                        inview.destroy();
                        inview.init();
                    }
                });
            });
            const config = {
                childList: true,
                subtree: true
            };
            observer.observe(target, config)
        }
    };

    // public
    return {
        init: init,
        loaded: loaded,
        scrolled: scrolled,
        resized: resized
    };
})();

$(() => {
    main.init();
});

$(window).on('load', () => {
    const urlHash = location.hash;
    if(!urlHash){
        main.loaded();
    }
});

$(window).on('scroll', () => {
    main.scrolled();
});

$(window).on('resize', () => {
    setTimeout(() => {
        main.resized();
    }, 100);
});
